import request from '@/utils/request'
export const baseApi = {
  // openid获取用户信息
  getuserinfobyopenid: (params) => {
    return request.get(`api/business/getuserinfobyopenid`, { params: params })
  },
  // 用户信息
  getuserinfo: (params) => {
    return request.get(`api/business/getuserinfo`, { params: params })
  },
  // 用户详情
  getuserbindInfo: (params) => {
    return request.get(`api/business/getuserbindInfo`, { params: params })
  },
  // 获取地区
  getsendarea: (params) => {
    return request.get(`api/business/getsendarea`, { params: params })
  },
  // 购买
  pay: (params) => {
    return request.get(`api/business/pay`, { params: params })
  },
  // 查询订单
  getpay: (params) => {
    return request.get(`api/business/getpay`, { params: params })
  },
  // vip列表
  getshipLevel: (params) => {
    return request.get(`api/business/getshipLevel`, { params: params })
  },
  // 积分规则
  pointRemark: (params) => {
    return request.get(`api/business/pointRemark`, { params: params })
  },
  // 获取成交案例
  getNewsCategoryList: (params) => {
    return request.get(`api/business/getNewsCategoryList`, { params: params })
  },
  // 获取成交案例详情
  getNewsDetail: (params) => {
    return request.get(`api/business/getNewsDetail`, { params: params })
  },
  // 新增消费记录
  addpurchaserecord: (params) => {
    return request.get(`api/business/addpurchaserecord`, { params: params })
  },
  // 获取全部地址
  getAllSetArea: (params) => {
    return request.get(`api/business/getAllSetArea`, { params: params })
  },
  // 获取内容 1关于我们 2协议
  getAboutUs: (params) => {
    return request.get(`api/business/getAboutUs`, { params: params })
  },
  // 获取地区
  getPurchaseArea: (params) => {
    return request.get(`api/business/getPurchaseArea`, { params: params })
  },
  // 获取手机号地区
  getAreaByPhone: (params) => {
    return request.get(`api/business/getAreaByPhone`, { params: params })
  },
  // 获取规格列表
  getunit: (params) => {
    return request.get(`api/push/getunit`, { params: params })
  },
  // 生成邀请码
  createPersonalCode: (params) => {
    return request.get(`api/business/createPersonalCode`, { params: params })
  },
  // 检测是否已绑定邀请码
  checkInvitationCode: (params) => {
    return request.get(`api/business/checkInvitationCode`, { params: params })
  },
  // 生成公众号二维码
  createQR: (params) => {
    return request.get(`api/business/CreateQR`, { params: params })
  },
  // 操作记录
  ceshi: (params) => {
    return request.get(`api/business/ceshi`, { params: params })
  },
  // 公众号设置
  getproductSet: (params) => {
    return request.get(`api/business/getproductSet`, { params: params })
  },
  // 分享给好友
  getsigndata: (params) => {
    return request.get(`api/business/getsigndata`, { params: params })
  },
  // 获取base64
  getbase64: (params) => {
    return request.get(`api/business/getbase64`, { params: params })
  },
}
